import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  forgotPassword,
  login,
  selectIsAuthenticate,
} from "@/core/store/authSlice";
import { FormInput } from "components/basic/FormInput";
import { ButtonRound } from "components/basic/Buttons";

type Props = {
  email: string;
};

// Always-on inline login panel — visible as soon as the email field is present,
// never conditional on a check_account API call (which would reveal whether an
// email is registered — account enumeration / GDPR violation).
// Login failure and forgot-password responses are kept generic server-side.
export const RegisterUserPasswordField = React.memo(({ email }: Props) => {
  const [password, setPassword] = useState("");
  const dispatch = useAppDispatch();
  const isAuthenticate = useAppSelector(selectIsAuthenticate);

  // Hide once the user is logged in — form pre-fills from session at that point
  if (isAuthenticate) return <></>;

  return (
    <div className="mt-1 mb-3 rounded-xl bg-gray-50 border border-gray-200 p-4">
      <p className="text-sm font-medium text-gray-600 mb-3">
        Already a customer? Sign in to skip ahead.
      </p>
      <FormInput
        label="Password"
        type="password"
        autocomplete="current-password"
        placeholder="Password"
        name="nr_pw_inline"
        onChange={(e) => {
          const target = e.target as typeof e.target & { value: string };
          setPassword(target.value);
        }}
        onKeyUp={(event: KeyboardEvent) => {
          if (event.key === "Enter") {
            event.preventDefault();
            if (email) dispatch(login({ email, password }));
          }
        }}
        value={password}
      />
      <div className="flex items-center gap-4 mt-3">
        <ButtonRound
          type="success"
          text="Sign in"
          buttonType="button"
          className="h-9 px-5"
          onClick={() => {
            if (email) dispatch(login({ email, password }));
          }}
        />
        <button
          className="text-sm text-blue-600 hover:underline"
          type="button"
          onClick={() => {
            if (email) dispatch(forgotPassword({ email }));
          }}
        >
          Forgot password?
        </button>
      </div>
    </div>
  );
});
